import { EffectCallback, useEffect } from "react";

import { useStableRef } from "./useStableRef";

/**
 * A version of useEffect() that only runs on mount/unmount, ignoring any changes to reactive values used by the callback
 * - the callback is called each time the component mounts (twice in strict mode)
 * - the return value of the callback (if provided) is called each time the component unmounts
 * - the callback does not re-run while its component remains mounted
 */
export function useOnMount(onMount: EffectCallback) {
  const onMountRef = useStableRef(onMount);
  useEffect(() => onMountRef.current(), [onMountRef]);
}
